import Commons from '../shared/libraries/commons';
import { BaseSerializer } from '/src/app/core/serializers/baseSerializer';

class AffiliationSerializer extends BaseSerializer {
  deserialize(raw, isLatestTransations) {
    const serverRes = raw.data || raw.error;
    const success = serverRes.statusCode == 200 || serverRes.statusCode == 404;
    if (success) {
      return {
        statuCode: 200,
        success: true,
        message: 'List got',
        data: (serverRes?.data || [])
          .map(formatTrx)
          .filter((el) => el.operation == 'fund')
      };
    }
    return {
      statusCode: serverRes.statusCode || raw.status || 500,
      success: false,
      message:
        serverRes.message ||
        'Impossible de charger vos affiliations. Veuillez réessayer plus tard.',
      // ancien message: (serverRes.message || 'Erreur lors de la récupération') + ` Code d'erreur: AFF_ERR_${serverRes.statusCode || raw.status || '1000'}`
      data: null
    };
  }

  serialize() {}

  deserializeTransactoinDetail(raw) {
    const serverRes = raw.data || raw.error;
    const success = serverRes.statusCode == 200 || serverRes.statusCode == 404;
    if (!success) {
      return {
        statusCode: serverRes.statusCode || raw.status || 500,
        success: false,
        message:
          serverRes.message ||
          "Impossible de charger les détails de l'affiliation. Veuillez réessayer.",
        // ancien message: (serverRes.message || 'Erreur lors de la récupération') + ` Code d'erreur: TRX_ERR_${serverRes.statusCode || raw.status || '1000'}`
        data: null
      };
    }

    return {
      statuCode: 200,
      success: true,
      message: 'Found',
      data: formatTrx(serverRes.data)
    };
  }
}

function formatTrx(trx) {
  const isFund = trx.operation === 'fund';
  const isWithdraw = trx.operation === 'withdraw';

  return {
    /** Identité */
    id: trx.id,
    bookmakerId: trx.bookmakerId,
    service: trx.service,
    bookmaker: trx.bookmaker,
    operation: trx.operation,

    /** Affichage */
    logo: trx.serviceLogo,
    operationNameDisplay: trx.operationName,

    /** Dates */
    startDate: Commons.time(trx.createdAt, 'DD MMM YYYY - HH:mm'),
    createdAt: trx.createdAt,

    /** Montants */
    amountToSend: trx.fees?.srcAmount,
    currencyToSend: 'XOF',

    amountToReceive: trx.fees?.dstAmount,
    bonusReceived: parseInt((trx.fees?.dstAmount * 5) / 100),
    currencyToReceive: 'XOF',

    fee: trx.fees?.fee,
    feeCurrency: 'XOF',

    bonus: trx.fees?.bonus,
    earning: trx.fees?.earning,

    /** Détail des frais */
    feeBreakdown: {
      srcServiceFee: trx.fees?.srcServiceFee,
      dstServiceFee: trx.fees?.dstServiceFee,
      srcProcessorFee: trx.fees?.srcProcessorFee,
      dstProcessorFee: trx.fees?.dstProcessorFee,
      earning: trx.fees?.earning,
      bonus: trx.fees?.bonus
    },

    collectStatus: statusGroup?.[trx.collectStatus] || 'unknown',
    collectStatusDisplay: statusDisplay?.[trx.collectStatus] || 'Inconnu',
    collectStatusDetailed: statusDetailed?.[trx.collectStatus] || null,

    depositStatus: statusGroup?.[trx.depositStatus] || 'unknown',
    depositStatusDisplay: statusDisplay?.[trx.depositStatus] || 'Inconnu',
    depositStatusDetailed: statusDetailed?.[trx.depositStatus] || null,

    /** Utilisateur */
    senderFirstName: trx.userFirstName,
    senderLastName: trx.userLastName,
    senderEmail: trx.userEmail,
    senderPhoneNumber: trx.userPhoneNumber,
    senderCountryCode: trx.userCountryCode,

    /** Paiement */
    paymentMethod: trx.paymentMethod,
    senderPhoneNumberUsed: trx.senderPhoneNumber,
    recipientPhoneNumber: trx.recipientPhoneNumber,

    /** Métadonnées utiles */
    operationDetails: getOperationDetail(trx),

    /** Brut pour vue détail */
    rawData: trx
  };
}

function getOperationDetail(trx) {
  if (trx.operation == 'fund') {
    return {
      collectName: 'Paiement',
      depositName: `Recharge ${trx.service}`,
      paymentMethod: trx.paymentMethod,
      service: trx.service,
      bookmaker: trx.bookmaker
    };
  }
  if (trx.operation == 'withdraw') {
    return {
      collectName: `Retrait ${trx.service}`,
      depositName: `Dépost sur ${trx.service}`,
      paymentMethod: trx.paymentMethod,
      service: trx.service,
      bookmaker: trx.bookmaker
    };
  }
}

const statusGroup = {
  error: 'error',
  failed: 'error',
  created: 'pending',
  pending: 'pending',
  lockedInPending: 'pending',
  success: 'success',
  paid: 'success',
  refunded: 'error',
  unpaid: 'pending',
  collected: 'pending',
  paidFailed: 'pending'
};

const statusDisplay = {
  success: 'Réussi',
  paid: 'Réussi',
  validated: 'Réussi',
  error: 'Échouée',
  failed: 'Échouée',
  created: 'En cours',
  pending: 'En cours',
  unpaid: 'Recharge en cours',
  refunded: 'Remboursé',
  collected: 'En cours',
  paidFailed: 'En cours',
  funding_failed: 'Echec de dépot',
  not_subscribed: 'Abonnement échoué',
  transaction_timeout: 'Transaction expirée sans confirmation du paiement',
  transaction_failed: "Le paiement n'a pas été confirmé",
  failed_amount_missmatch:
    "Le montant entre votre transaction et l'opérateur sont différent",
  merchant_balance_is_low: 'Erreur',
  subscriber_balance_is_low: 'Le solde du compte est insuffisant',
  not_enough_money: 'Pas assez de fonds sur le wallet Kingrecharge',
  min_amount_error: 'Le montant entré est inférieur au minimum autorisé',
  failed_to_launch_collect: "Echec d'initiation de la récupération de fond",
  failed_to_launch_deposit: "Echec d'initiation du recharge",
  bad_transaction_data: 'Les données de la transaction ne sont pas correcte',
  bad_otp_code: "Le code otp entré n'est pas correct",
  same_operation_in_short_period:
    'Une transaction avec les même données a été lancée récement. Veuillez patienter puis relancer dans quelqeus minutes'
};

const statusDetailed = {
  success: 'Transaction effectué avec succès',
  paid: 'Transaction effectué avec succès',
  validated: 'Transaction effectué avec succès',

  error: 'L’opération a échoué',
  failed: 'L’opération a échoué',

  created: 'Transaction initiée et en attente de traitement',
  pending: 'Transaction en cours de traitement',

  unpaid: 'Recharge initié, en attente de confirmation',
  refunded: 'Montant remboursé au client',

  collected: 'Paiement réussi, confirmation en attente',
  paidFailed: 'Paiement réussi, confirmation en attente',

  funding_failed: 'Échec lors de la tentative de dépôt',
  not_subscribed: 'Échec : l’abonnement n’a pas été activé',

  transaction_timeout:
    'La transaction a expiré faute de confirmation du paiement',
  transaction_failed: 'Le paiement n’a pas pu être confirmé',

  failed_amount_missmatch:
    'Incohérence détectée : le montant envoyé ne correspond pas à celui de l’opérateur',

  merchant_balance_is_low: 'Solde insuffisant sur le compte marchand',
  subscriber_balance_is_low: 'Solde insuffisant sur le compte utilisateur',

  not_enough_money: 'Fonds insuffisants sur le wallet',

  min_amount_error: 'Le montant saisi est inférieur au minimum autorisé',

  failed_to_launch_collect:
    'Impossible d’initier la demande de collecte de fonds',
  failed_to_launch_deposit: 'Impossible d’initier la demande de dépôt',

  bad_transaction_data:
    'Les informations fournies pour la transaction sont incorrectes ou incomplètes',

  bad_otp_code: 'Le code OTP saisi est invalide. Veuillez réessayer.',

  same_operation_in_short_period:
    'Une opération similaire a été effectuée récemment. Merci de patienter quelques minutes avant de réessayer.'
};

const operationNameDisplay = {
  wallet_funding: 'Recharge de wallet',
  send_money_option1: 'Envoi d’argent',
  send_money_option2: 'Envoi d’argent',
  ask_money: 'Demande d’argent',
  buy_airtime: 'Achat de crédit',
  buy_databundle: "Achat d'internet",
  buy_carrierbundle: 'Achat de forfait',
  buy_giftcard: 'Achat de carte cadeau',
  buy_bank_card: 'Achat de carte bancaire',
  buy_physical_bank_card: 'Achat de carte bancaire',
  fund_physical_bank_card: 'Recharge de carte bancaire',
  pay_fundraise: 'Paiement pour cagnotte',
  unknown: 'Inconnu'
};

export const serializer = new AffiliationSerializer();
